import { Subject, Observable, from } from 'rxjs';
import {
  CrossFrameBridge,
  CrossFrameBridgeOptions,
} from './cross-frame-bridge';

export class CrossFrameObservableBridge extends CrossFrameBridge {
  private eventSubjects = new Map<string, Subject<{ payload: any; origin: string }>>();
  private publishSubjects = new Map<string, Subject<{ payload: any; origin: string }>>();

  constructor(options: CrossFrameBridgeOptions) {
    super(options);
  }

  override handleIncomingMessage(event: MessageEvent): void {
    const { data, origin } = event;
    if (typeof data !== 'object' || !data.type || !data.action) return;

    if (data.type === 'event') {
      const subject = this.eventSubjects.get(data.action);
      subject?.next({ payload: data.payload, origin });
    }

    if (data.type === 'publish') {
      const subject = this.publishSubjects.get(data.action);
      subject?.next({ payload: data.payload, origin });
    }

    super.handleIncomingMessage(event);
  }

  onEvent$<T = any>(action: string): Observable<{ payload: T; origin: string }> {
    if (!this.eventSubjects.has(action)) {
      this.eventSubjects.set(action, new Subject());
    }
    return this.eventSubjects.get(action)!.asObservable();
  }

  onPublish$<T = any>(action: string): Observable<{ payload: T; origin: string }> {
    if (!this.publishSubjects.has(action)) {
      this.publishSubjects.set(action, new Subject());
    }
    return this.publishSubjects.get(action)!.asObservable();
  }

  sendRequest$<T = any>(action: string, payload: any): Observable<T> {
    return from(this.sendRequest<T>(action, payload));
  }

  override destroy(): void {
    super.destroy();
    for (const subj of this.eventSubjects.values()) subj.complete();
    for (const subj of this.publishSubjects.values()) subj.complete();
    this.eventSubjects.clear();
    this.publishSubjects.clear();
  }
}
